(function ($) {
	
	$.fn.audioPlayer = function () {
		
		var elem = $(this);
		
		var init = function () {
			console.log('audio');
			maudio({
				obj:      'audio',
				fastStep: 10
			});
			
			
			//$('audio')[0].pause();
			
			$('audio').bind('canplay', function () {
				
				$('.episode-guide__entry').on('click', function (event) {
					
					event.preventDefault();
					console.log('Go');

					var timestamp = $(this).attr('href').split('#');
                    var time = $(this).find('.episode-guide__entry__time').html();
                    var audioBox = $('.audio-control .progress-bar').parent('.audio-control').parent('.maudio');
                    var p = timestamp[1] / audioBox.find('.progress-bar').width();
                    var progress = p * 100 / 10;
					
					//console.log(timestamp[1]);
					
					$('audio')[0].currentTime = timestamp[1];
                    $('.current-time').html(time);
                    audioBox.find('.progress-pass').css({"width":progress + '%'});
										
				});
				
			});
			
		};
		
		init();
		
		return this;
		
	};
	
}(jQuery));